<mat-form-field appearance="fill" class="w-full ">
    <mat-label>{{label}}</mat-label>
    <input matInput [formControl]="textControl" placeholder="{{placeholder}}" class="focus:ring-0" (blur)="onBlur()"
        [disabled]="disabled" [readonly]="readonly" [maxlength]="maxlength">
    @if (textControl.hasError('required') && textControl.touched) {
    <mat-error>{{label}} {{"PARKIFLY.ERROR.IS_REQUIRED" | transloco}}</mat-error>
    }
    @if (textControl.hasError('maxlength') && textControl.touched) {
    <mat-error>{{"PARKIFLY.ERROR.MAX_LENGTH" | transloco : {label: label, length:
        $safeNavigationMigration(textControl.errors?.['maxlength']?.requiredLength)} }}</mat-error>
    }
    <!-- @if (textControl.hasError('pattern') && textControl.touched) {
    <mat-error>{{"PARKIFLY.ERROR.INVALID_REG_NR" | transloco}}</mat-error> -->
    <!-- } -->
    @if (textControl.hasError('qualityXpoBookingNumber') && textControl.touched) {
    <mat-error>{{"PARKIFLY.ERROR.QUALITY_XPO_BOOKING_NUMBER" | transloco}}</mat-error>
    }
    @if (textControl.hasError('minlength') && textControl.touched) {
    <mat-error>{{"PARKIFLY.ERROR.MIN_LENGTH" | transloco : {label: label, length:
        $safeNavigationMigration(textControl.errors?.['minlength']?.requiredLength)} }}</mat-error>
    }
</mat-form-field>